/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommunityControllerDtoPostExcelDownloadRequest model module.
 * @module model/CommunityControllerDtoPostExcelDownloadRequest
 * @version 1.0
 */
class CommunityControllerDtoPostExcelDownloadRequest {
    /**
     * Constructs a new <code>CommunityControllerDtoPostExcelDownloadRequest</code>.
     * @alias module:model/CommunityControllerDtoPostExcelDownloadRequest
     * @param postNo {Number} 
     */
    constructor(postNo) { 
        
        CommunityControllerDtoPostExcelDownloadRequest.initialize(this, postNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, postNo) { 
        obj['postNo'] = postNo;
    }

    /**
     * Constructs a <code>CommunityControllerDtoPostExcelDownloadRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommunityControllerDtoPostExcelDownloadRequest} obj Optional instance to populate.
     * @return {module:model/CommunityControllerDtoPostExcelDownloadRequest} The populated <code>CommunityControllerDtoPostExcelDownloadRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunityControllerDtoPostExcelDownloadRequest();

            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommunityControllerDtoPostExcelDownloadRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommunityControllerDtoPostExcelDownloadRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CommunityControllerDtoPostExcelDownloadRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CommunityControllerDtoPostExcelDownloadRequest.RequiredProperties = ["postNo"];

/**
 * @member {Number} postNo
 */
CommunityControllerDtoPostExcelDownloadRequest.prototype['postNo'] = undefined;






export default CommunityControllerDtoPostExcelDownloadRequest;

